<template>
    <div>
        <h1>{{$t('Error')}}</h1>
        <h2>{{$t(errorMessage)}}</h2>
    </div>
</template>

<script>
    export default {
        data() {
            errorMessage: ''
        },
        created: function () {
            let urlErrorMessage = this.$route.query.error;
            if (urlErrorMessage) {
                this.errorMessage = urlErrorMessage;
            }
        }
    }
</script>

<style scoped>
    h1 {margin-top: 40px; margin-bottom: 20px}
</style>



// WEBPACK FOOTER //
// src/views/payments/PaymentFailure.vue